import {importProfile} from "./match-profile";

export function importJob(job) {
    return {
        ...job,
        matchProfile: importProfile(job.matchProfile),
    };
}
